import { PureComponent } from "react";
import componentStyles from "./footer-bottom-bar-component.scss";
import PaletteIconsComponent from "./palette-icons/palette-icons-component";
import { LONG_FOOTER_BOTTOM_LINKS } from "/constants/links";
import classNames from "classnames";
import LanguagePickerComponent from "/components/core/language-picker/language-picker-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { DIALOG_DIRECTIONS } from "components/core/language-picker/language-picker-service";
import AccessibilityStatementLinkComponent from "components/accessibility/accessibility-statement-link/accessibility-statement-link-component";
import linkTypesComponents from "./links/index";

class FooterBottomBarComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderLinks() {
    const { localeId } = this.props;

    return LONG_FOOTER_BOTTOM_LINKS.map((linkData) => {
      const { title, componentName } = linkData;
      const ComponentToRender = linkTypesComponents[componentName];

      return (
        <div key={title} className={classNames("short-footer-link-component-wrapper")}>
          <ComponentToRender localeId={localeId} {...linkData} />
          <style jsx>{componentStyles}</style>
        </div>
      );
    });
  }

  renderLanguagePicker() {
    return <LanguagePickerComponent dialogDirection={DIALOG_DIRECTIONS.ALIGN_TOP} />;
  }

  renderAccessibilityStatementLink() {
    return <AccessibilityStatementLinkComponent />;
  }

  render() {
    const { SocialFooterLinks } = this.props;

    return (
      <div className="footer-bottom-bar-component">
        <div className="items-container">
          <div className="links-container">
            {this.renderLinks()}
            <div className="accessibility-statement-link-wrapper">{this.renderAccessibilityStatementLink()}</div>
            <div className="language-picker-wrapper">{this.renderLanguagePicker()}</div>
          </div>
          <div className="palette-icons-wrapper">
            <PaletteIconsComponent SocialFooterLinks={SocialFooterLinks} />
          </div>
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withGenericConfig(FooterBottomBarComponent);
